import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { UserContext } from './UserContext';
var NAVIGATION_LOCAL_STORAGE_KEY = 'navigation_ui_state';
export function getNavigationStateWithDefaults(savedState) {
  var saved = savedState || {};
  return {
    expanded: saved.expanded || false
  };
}
export var BasicUserContextProvider = function BasicUserContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(function () {
    return getNavigationStateFromStorage();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      navigationState = _React$useState2[0],
      setNavigationState = _React$useState2[1];

  var setSidebarExpanded = function setSidebarExpanded(expanded) {
    var newState = _objectSpread(_objectSpread({}, navigationState), {}, {
      expanded: expanded
    });

    setNavigationState(newState);
    setNavigationStateInStorage(newState);
  };

  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      navigation: navigationState,
      setSidebarExpanded: setSidebarExpanded
    }
  }, children);
};
export function setNavigationStateInStorage(state) {
  return localStorage.setItem(NAVIGATION_LOCAL_STORAGE_KEY, _JSON$stringify(state));
}
export function getNavigationStateFromStorage() {
  var storageNavigationState = localStorage.getItem(NAVIGATION_LOCAL_STORAGE_KEY);
  var parsedStorageNavigationState = null;

  if (storageNavigationState) {
    try {
      parsedStorageNavigationState = JSON.parse(storageNavigationState);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error when parsing JSON from navigation state in local storage.\n        Key: '".concat(NAVIGATION_LOCAL_STORAGE_KEY, "' Value: '").concat(storageNavigationState, "'"), e);
    }
  }

  return getNavigationStateWithDefaults(parsedStorageNavigationState);
}